// includTrack(id, calls): one call for a custom event, for the Includ apps and the website.
//
// calls: one per tool, e.g.
//   { tool: 'firebase',  name: 'wishlist_add', params: {...} }
//   { tool: 'clevertap', name: 'Added to Wishlist', props: {...} }
//   { tool: 'meta',      name: 'fb_mobile_add_to_wishlist', webName: 'AddToWishlist', params: {...} }
//   { tool: 'branch',    standard: 'ADD_TO_WISHLIST', ... }
// In the Includ app the calls go to the app, which checks and sends them (app-tracking/README.md).
// On the website (and in older apps) they go through the tags already on the page, after the next
// paint so a tap never waits for tracking. Branch gets nothing from the website.
// Use it on the website only for events no Shopify app already sends there, or they count twice.
(function () {
  var GA4 = 'G-72RB76VELD';

  function web(calls) {
    calls.forEach(function (c) {
      if (c.tool === 'firebase' && typeof window.gtag === 'function') {
        var p = {};
        for (var k in c.params || {}) p[k] = c.params[k];
        p.send_to = GA4;
        p.includ_platform = window.includIsApp ? 'APP' : 'WEB'; // as the wrapper in assets/custom-ga-events.js
        window.gtag('event', c.name, p);
      } else if (c.tool === 'clevertap' && window.clevertap && window.clevertap.event) {
        window.clevertap.event.push(c.name, c.props || {});
      } else if (c.tool === 'meta' && typeof window.fbq === 'function') {
        if (c.webName) window.fbq('track', c.webName, c.params || {});
        else window.fbq('trackCustom', c.name, c.params || {});
      }
    });
  }

  window.includTrack = function (id, calls) {
    var app = window.includApp;
    if (app && typeof app.send === 'function') return app.send('track', { id: id, calls: calls });
    window.requestAnimationFrame(function () {
      window.setTimeout(function () { web(calls); }, 0);
    });
  };
})();
